import React from 'react'

const Accessories = () => {
    return (
        <div className="no-gutters banner accessories">
            
        </div>
    )
}

export default Accessories
